import React from 'react';
import Link from 'next/link';

const Blogtags = () => {
  return (
    <div className="columns categories">
        <span className="title"><h2 className='text-[#ffff] text-3xl'>Tags</h2></span>
        <section className='shadow-lg '>
          <p className='text-[14px]'>
          <Link href="#">Corporate</Link>
          <Link href="#">Campus</Link>
          <Link href="#">Readings</Link>
          <Link href="#">Student</Link>
          <Link href="#">Collages</Link>
          </p>
        </section>
      </div>
  )
}

export default Blogtags